export enum ActionConfirmationStatuses {
  ACTION_CONFIRMED = 'ACTION_CONFIRMED',
  MATERIALS_READY = 'MATERIALS_READY',
  ACTION_READY = 'ACTION_READY',
}
